export class SucceededDeclarationInfo {
    constructor(
        public declarationType: string,
        public showPointsNotification: boolean,
        public hasDuplicateSerialNumberAnomaly: boolean,
        public pointsEarned: number,
        public newBalance: number,
      ) {  }
  }